<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'AdBluePurchase' | translate"></app-sub-header>

<div class="padded-container">
  <form (ngSubmit)="saveClick()">
    <dx-form>
      <dxi-item>
        <dxo-label text="{{ 'AdBlueAmount' | translate }}"></dxo-label>
        <dx-number-box [(value)]="adBlueAmount"
  [min]="0"
  [max]="1000"
  [step]="0.01"
  [showSpinButtons]="true"
  [format]="{ type: 'fixedPoint', precision: 2 }"
  class="full-width-button">
</dx-number-box>
      </dxi-item>
      <dxi-item>
  <dxo-label text="{{ 'ReceiptNumber' | translate }}"></dxo-label>
  <dx-number-box [(value)]="adBlueReceiptNumber"
           [min]="0"
           [max]="999999999"
           [showSpinButtons]="true"
           [format]="'decimal'"
           class="full-width-button"></dx-number-box>
      </dxi-item>
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Save' | translate }}" type="success" (onClick)="saveClick()"></dx-button>
      </dxi-item>
      <dxi-item>
        <dx-button class="full-width-button" text="{{ 'Back' | translate }}" type="default" (onClick)="navigateToVoucher()"></dx-button>
      </dxi-item>
    </dx-form>
  </form>

  <div *ngIf="adBlueResponse">
    <div class="container">
      <div *ngIf="adBlueResponse">
        <label>{{ 'AdBluePurchase' | translate }}</label>
        <div *ngFor="let group of adBlueResponse.fuelList">
          <div class="ad-blue-group">
            <label>{{ 'ReceiptNumber' | translate }}</label>
            <dx-text-box [(value)]="group.receiptNumber" class="full-width-button" [readOnly]="true" [inputAttr]="{ inputmode: 'numeric', pattern: '[0-9]*' }"></dx-text-box>
            <label>{{ 'AdBlueAmount' | translate }}</label>
            <dx-number-box [value]="group.amount ?? 0" class="full-width-button" [readOnly]="true"></dx-number-box>
          </div>
        </div>
      </div>
    </div>
  </div>

  <dx-popup [(visible)]="popupVisibleError" title="{{ 'Notification' | translate }}" [width]="isMobile ? '100%' : '60%'"
  [height]="isMobile ? '100%' : '80%'" [class.full-screen-popup]="isMobile" [hideOnOutsideClick]="false" [showCloseButton]="true">
    <div *dxTemplate="let data of 'content'">
      <p [innerHTML]="errorMessage"></p>
    </div>
  </dx-popup>
</div>
</div>